import React, { useState, useEffect } from 'react';
import { SearchIcon } from '../../appearence/icons/search_icon';
import { hintsService } from './hintsService';

const SearchInput = ({ CustomRouter, setIsActive, restoreHints, isMobile, isLoading, productsCount }) => {
    const [searchValue, setSearchValue] = useState('');
    const [searchListLength, setSearchListLength] = useState(0);
    const [isFocused, setIsFocused] = useState(false);

    const formatNumber = (num) => {
        if (!num || num === 0) return "10 000 000"; 
        return num.toLocaleString('ru-RU');
    };

    const placeholderText = isLoading 
        ? "Загрузка..."
        : isMobile 
            ? `Поиск среди ${formatNumber(productsCount)} товаров...`
            : `Поиск среди ${formatNumber(productsCount)} компонентов, комплектующих и оборудования`;

    useEffect(() => {
        setIsActive(isFocused || searchListLength > 0);
    }, [isFocused, searchListLength, setIsActive]);

    const performSearch = async () => {
        if (searchValue.length >= 3) {
            hintsService.setSearchValue(searchValue);
            await hintsService.saveSearchHistory(searchValue);
            await hintsService.storeSearchQuery(searchValue);
            window.location.href = `/search?q=${searchValue}&offset=0&limit=5`;
        }
    };

    const handleKeyDown = async (e) => {
        if (e.key === "Enter") {
            await performSearch();
        }
    };

    const handleSearchIconClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await performSearch();
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        hintsService.setSearchValue(value);
    };

    useEffect(() => {
        const changeSearchListLength = (hintsList) => {
            setSearchListLength(hintsList.length);
        };
        hintsService.registerHintsObserver(changeSearchListLength);
        return () => hintsService.unRegisterHintsObserver(changeSearchListLength);
    }, []);

    const handleSearchInputClick = (e) => {
        e.stopPropagation();
    };

    const handleBlur = (e) => {
        if (!e.relatedTarget || !e.relatedTarget.closest('.search-options__list')) {
            setIsFocused(false);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        if (searchValue.length >= 3) {
            restoreHints();
        }
    };

    return (
        <label className="menu-common__search gg1243" onKeyDown={handleKeyDown}>
            <div 
                onClick={handleSearchIconClick}
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 102,
                    height: '100%',
                    width: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    pointerEvents: 'auto',
                }}
            >
                <SearchIcon />
            </div>
            <input
                className={`menu-common__search-input menu-middle__search-input ${isFocused || searchListLength ? 'menu-common__search-input_active menu-middle__search-input_active' : ''}`}
                placeholder={placeholderText}
                value={searchValue}
                onClick={handleSearchInputClick}
                onChange={handleInputChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </label>
    );
};

export default SearchInput;

